module.exports = __webpack_public_path__ + "img/itob_ctimg03.6177be4e.png";